import React from "react";

const DownloadIcon = ({ size = 18 }) =>
  <svg width={size} height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 11.3333V12.2667C16 13.5735 16 14.2269 15.7457 14.726C15.522 15.165 15.165 15.522 14.726 15.7457C14.2269 16 13.5735 16 12.2667 16H5.73333C4.42654 16 3.77315 16 3.27402 15.7457C2.83498 15.522 2.47802 15.165 2.25432 14.726C2 14.2269 2 13.5735 2 12.2667V11.3333M12.8889 7.44444L9 11.3333M9 11.3333L5.11111 7.44444M9 11.3333V2" stroke="#69687A" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
  ;

export default DownloadIcon;

